import { supabase } from '@/lib/supabase';
import type { MovementType } from '@/types';

export interface SaveMovementInput {
  id?: string;
  movement_type: MovementType;
  movement_date: string;
  category: string;
  concept: string;
  amount: number;
  project_id: string | null;
  createdBy: string | null;
  createdByName: string;
}

/** Crea o actualiza un movimiento financiero registrando su autoría. */
export async function saveMovement(input: SaveMovementInput): Promise<void> {
  if (input.id) {
    const { error } = await supabase
      .from('financial_movements')
      .update({
        movement_type: input.movement_type,
        movement_date: input.movement_date,
        category: input.category,
        concept: input.concept.trim(),
        amount: input.amount,
        project_id: input.project_id,
        updated_at: new Date().toISOString(),
      })
      .eq('id', input.id);
    if (error) throw error;
    return;
  }

  const { error } = await supabase.from('financial_movements').insert({
    movement_type: input.movement_type,
    movement_date: input.movement_date,
    category: input.category,
    concept: input.concept.trim(),
    amount: input.amount,
    project_id: input.project_id,
    created_by: input.createdBy,
    created_by_name: input.createdByName,
  });
  if (error) throw error;
}

export async function deleteMovement(id: string): Promise<void> {
  const { error } = await supabase.from('financial_movements').delete().eq('id', id);
  if (error) throw error;
}